module.exports = __webpack_public_path__ + "assets/img/18_173_big.57d421ff.jpg";